let sketchpadConfig: SketchpadConfig = {
    maxDropWidth: 300,
    footerPhysicsArea: {
        width: 300,
        height: 150,
        left: 0,
        bottom: -175
    },
    keyMap: {
        pageSize: "cubeData.pageSize",
        dataMap: "cubeData.dataMap",
        id: "cubeData.id",
        status: "cubeData.status",
        created: "cubeData.created",
        modified: "cubeData.modified",
        yn: "cubeData.yn",
        creator: "cubeData.creator",
        updator: "cubeData.updator",
        originId: "cubeData.originId",
        venderId: "cubeData.venderId",
        categoryId: "cubeData.categoryId",
        displayName: "cubeData.displayName",
        drawingWidth: "cubeData.drawingWidth",
        drawingHeight: "cubeData.drawingHeight",
        drawingDepth: "cubeData.drawingDepth",
        contacts: "cubeData.contacts",
        contactsPhone: "cubeData.contactsPhone",
        version: "cubeData.version",
        drawingState: "cubeData.drawingState",
        publishState: "cubeData.publishState",
        onlineTime: "cubeData.onlineTime",
        offlineTime: "cubeData.offlineTime",
        planDate: "cubeData.planDate",
        effectiveTime: "cubeData.effectiveTime",
        invalidTime: "cubeData.invalidTime",
        remark: "cubeData.remark",
        createUserId: "cubeData.createUserId",
        modifyUserId: "cubeData.modifyUserId",
        modifyUserName: "cubeData.modifyUserName",
        propCfg: "cubeData.propCfg",
        upgradeFlag: "cubeData.upgradeFlag",
        frontData: "cubeData.frontData",
        selfQueryParams: "cubeData.selfQueryParams",
        selfQueryContact: "cubeData.selfQueryContact",
        selfQueryDOS: "cubeData.selfQueryDOS",
        categoryName: "cubeData.categoryName",
        categoryInfo: "cubeData.categoryInfo",
        venderIds: "cubeData.venderIds",
        queryPlanDate: "cubeData.queryPlanDate",
        cfgList: "cubeData.cfgList",
        venderSapId: "cubeData.venderSapId",
        venderName: "cubeData.venderName",
        shelvesNumber: "cubeData.shelvesNumber",
        drawingStates: "cubeData.drawingStates",
        propCfgJson: "cubeData.propCfgJson",
        categoryInfoJson: "cubeData.categoryInfoJson",
        moduleGroups: "cubeData.moduleGroups"
    }
};

export default sketchpadConfig;
